import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GTBuySheetGuide from "../pages/gtbuy-sheet-guide/page";
import GTBuyPricingGuide from "../pages/gtbuy-pricing-guide/page";
import GTBuyTopCategories from "../pages/gtbuy-top-categories/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/gtbuy-sheet-guide",
    element: <GTBuySheetGuide />,
  },
  {
    path: "/gtbuy-pricing-guide",
    element: <GTBuyPricingGuide />,
  },
  {
    path: "/gtbuy-top-categories",
    element: <GTBuyTopCategories />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;